module.exports = {"TXTCLI_Share_link":{"id":"TXTCLI_Share_link","defaultMessage":"Κοινή χρήση συνδέσμου","track":"Share link"}}